import React from "react";

const Contact = () => {
  return (
    <div>
      <h1>I am contact us</h1>
      <h1>I am contact us</h1>
      <h1>I am contact us</h1>
      <h1>I am contact us</h1>
      <h1>I am contact us</h1>
      <h1>I am contact us</h1>
      <h1>I am contact us</h1>
      <h1>I am contact us</h1>
      <h1>I am contact us</h1>
      <h1>I am contact us</h1>
      <h1>I am contact us</h1>
      <h1>I am contact us</h1>
      <h1>I am contact us</h1>
      <h1>I am contact us</h1>
      <h1>I am contact us</h1>
      <h1>I am contact us</h1>
      <h1>I am contact us</h1>
      <h1>I am contact us</h1>
      <h1>I am contact us</h1>
      <h1>I am contact us</h1>
      <h1>I am contact us</h1>
      <h1>I am contact us</h1>
      <h1>I am contact us</h1>
      <h1>I am contact us</h1>
      <h1>I am contact us</h1>
      <h1>I am contact us</h1>
      <h1>I am contact us</h1>
      <h1>I am contact us</h1>
      <h1>I am contact us</h1>
    </div>
  );
};

export default Contact;
